import PropTypes from 'prop-types';
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Formatter from 'yoda-core-components/lib/helpers/Formatter/Formatter';
import SiteComponent from 'yoda-site-components/lib/components/SiteComponent/SiteComponent';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './StoreDetails.css';
import * as actions from '../../actions/GetStoreAction';

class StoreDetails extends SiteComponent {
    static propTypes = {
        storeId: PropTypes.string.isRequired,
        showLinkTitle: PropTypes.string,
        hideLinkTitle: PropTypes.string,
    };

    static defaultProps = {
        showLinkTitle: 'Store Details',
        hideLinkTitle: 'Hide details',
    };

    constructor() {
        super();
        this.state = { hideStoreDetails: true };
    }

    hydrateOnMount() {
        const { storeId, storeDetails } = this.props;
        if (isEmpty(storeDetails[storeId])) {
            this.props.actions.getStoreInfo(this.props.storeId);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    renderStoreSection(storeDetails) {
        return (
            <div data-automation-id="at-store-info" className={dt(['text-small', 'text-black'])}>
                <div>
                    <div data-automation-id="at-store-address-line-one">{storeDetails.street}</div>
                    <div data-automation-id="at-store-address-city-state-zip">
                        {storeDetails.city}, {storeDetails.state} {storeDetails.zip}
                    </div>
                    <div
                        is
                        x-ms-format-detection="none"
                        className="phoneNumber"
                        data-automation-id="at-store-phone-number"
                    >
                        {Formatter.format(storeDetails.phone, 0)}
                    </div>
                </div>
                <div data-automation-id="at-store-hours" className={dt(['pt-6', 'pb-4', 'px-0'])}>
                    {!isEmpty(storeDetails.timingsOverrideMessage) ? (
                        <div className={styles.storeHoursAndSelectButtonContainer}>
                            {/* eslint-disable react/no-danger */}
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: storeDetails.timingsOverrideMessage,
                                }}
                            />
                        </div>
                    ) : (
                        <div>
                            {storeDetails.timings.map((timing) => (
                                <div>{`${timing.days}: ${timing.time}`}</div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { storeId, storeDetails } = this.props;
        if (isEmpty(storeDetails[storeId])) {
            return null;
        }
        const storeDetailsInfo = storeDetails[storeId];
        return (
            <div
                data-automation-id="at-store-detail"
                className={(styles.storeDetails, dt(['text-normal']))}
            >
                <div className={dt(['mb-2'])} data-automation-id="at-store-name">
                    {storeDetailsInfo.name}
                </div>
                {this.renderStoreSection(storeDetailsInfo)}
            </div>
        );
    }
}

const mapStateToProps = ({ storeDetails }) => ({
    storeDetails,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StoreDetails);
